import styled from 'styled-components';

import { th } from '@yoweb/ui/styles/utils/theme';
import { media } from '@yoweb/ui/styles/utils';

const Td = styled.td`
  border: 1px solid;
  border-color: ${th.getColor('base900')};
  padding: ${th.getSpace('normal1')};
`;

const TdRegistration = styled.td`
  border-right: 1px solid;
  border-color: ${th.getColor('base900')};
  padding: ${th.getSpace('normal2')} ${th.getSpace('small3')};
  line-height: ${th.getLineHeight('bodyLg')};

  ${media.md`
    padding: ${th.getSpace('normal2')} ${th.getSpace('normal1')};
  `}

  &:last-of-type {
    border-right: none;
  }
`;

export { Td, TdRegistration };
export default Td;
